import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Currency } from '../currency';
import { CurrencyService } from '../currency.service';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { GlobalDataService } from '../../../../services/global-data.service';


@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css'],
  providers: [CurrencyService]
})
export class CurrencyComponent implements OnInit {

  currencies: Currency[];
  loading: boolean = false;
  msgs: Message[] = [];
  createMsg: string = ""; 
  // subscription: Subscription;

  constructor(
              private currencyService: CurrencyService,
              private activatedRoute: ActivatedRoute,
              private global: GlobalDataService,
              private router: Router
              ) {


      // activatedRoute.params.subscribe(params=>{console.log(params);this.createMsg=params['create']});
       // console.log(this.createMsg); 
      // if(this.createMsg){
          // 
      // }
      // 
      // this.subscription = this.global.getMessage().subscribe(data=>{  
                                                  //  console.log(data); 
                                                  // if(data.display){this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено "+data.text});};  
                                                
                                            //  });

   }  
  


  ngOnInit() {
    this.loading = true;
   
      // this.global.clearMessage();
    this.currencyService.getCurrency().subscribe(currency=>{this.currencies=currency['data'];this.loading= false;});
    
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }
  
  create():void{
	   this.router.navigate(['dashboard/currency-crud']); 	
  }

  clickedId(id: any){
     this.router.navigate(['dashboard/currency-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/currencies/currency/currency.component.ts